import type { LevelInput } from '@/lib/api/frameworkConfig'

/** Generate empty level array for a given count. */
export function emptyLevels(count: number): LevelInput[] {
  return Array.from({ length: count }, (_, i) => ({
    level_number: i + 1,
    label: '',
    description: '',
  }))
}
